import { render, staticRenderFns } from "./save-wrapper.component.vue?vue&type=template&id=561b2bc4"
import script from "./save-wrapper.component.ts?vue&type=script&lang=ts&external"
export * from "./save-wrapper.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('561b2bc4')) {
      api.createRecord('561b2bc4', component.options)
    } else {
      api.reload('561b2bc4', component.options)
    }
    module.hot.accept("./save-wrapper.component.vue?vue&type=template&id=561b2bc4", function () {
      api.rerender('561b2bc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/save-wrapper/save-wrapper.component.vue"
export default component.exports